var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
var TimeSlotPicker = function (_a) {
    //
    var indexV = _a.indexV;
    var partnerSelectedSlot = useSelector(function (state) { return state.markets.leadservice; }).partnerSelectedSlot;
    var _b = __read(useState(indexV || 0), 2), indexValue = _b[0], setValue = _b[1];
    var nextDays = Array.from({ length: 7 }, function (_, index) { return ({
        label: moment()
            .add(index + indexValue, "days")
            .format("YYYY-MM-DD"),
        value: moment()
            .add(index + indexValue, "days")
            .format("YYYY-MM-DD"),
    }); });
    var generateTimeSlots = function () {
        var customSlots = [
            { startHour: 9, endHour: 12, centerHour: "11" },
            { startHour: 13, endHour: 17, centerHour: "4" },
            { startHour: 17, endHour: 19, centerHour: "6" },
        ];
        return customSlots.map(function (_a) {
            var startHour = _a.startHour, endHour = _a.endHour, centerHour = _a.centerHour;
            var start = moment().startOf("day").add(startHour, "hours");
            var end = moment().startOf("day").add(endHour, "hours");
            return {
                label: "".concat(start.format("h A"), " - ").concat(end.format("h A")),
                value: "".concat(start.format("H"), "-").concat(end.format("H")),
            };
        });
    };
    var _c = __read(useState(generateTimeSlots()), 2), availableSlots = _c[0], setAvailableSlots = _c[1];
    var _d = __read(useState(""), 2), selectedTimeSlot = _d[0], setSelectedTimeSlot = _d[1];
    var updateAvailableSlots = function (date) {
        var updatedSlots = generateTimeSlots();
        setAvailableSlots(updatedSlots);
    };
    var handleSelectDate = useCallback(function (date) {
        updateAvailableSlots(date);
    }, []);
    var handleSelectTimeSlot = function (item) {
        setSelectedTimeSlot(item.value);
        aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: item.label }));
    };
    useEffect(function () {
        if (partnerSelectedSlot.date) {
            updateAvailableSlots(partnerSelectedSlot.date);
        }
        else {
            updateAvailableSlots(moment().format("YYYY-MM-DD"));
        }
    }, [partnerSelectedSlot.date]);
    useEffect(function () {
        var selectedDate = moment(partnerSelectedSlot.date).format("YYYY-MM-DD");
        var futureSlots = availableSlots.filter(function (item) {
            var slotStartTime = moment("".concat(selectedDate, " ").concat(Number(item.value.split("-")[1]) - 1), "YYYY-MM-DD H");
            return !moment().isAfter(slotStartTime);
        });
        if (futureSlots.length > 0) {
            setSelectedTimeSlot(futureSlots[0].value);
            aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: futureSlots[0].label }));
        }
        else {
            setValue(1);
            setSelectedTimeSlot("");
        }
    }, [availableSlots, partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date]);
    useEffect(function () {
        if (indexValue > 0) {
            handleSelectDate(nextDays[0].value);
            aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { date: nextDays[0].value }));
        }
    }, [indexValue]);
    return (React.createElement("div", { className: "top-container time-slot-picker mx-3" },
        React.createElement("label", { className: "DMSansMedium_12_500 $black-one1" }, "Choose a time-slot"),
        React.createElement("div", { className: "position-relative w-full" },
            React.createElement("select", { className: "date-selector DMSanN_14_400 w-full form-select appearance-none", onChange: function (event) {
                    var value = event.target.value;
                    handleSelectDate(value);
                    aifPmsDi.leadservice.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { date: value }));
                } }, nextDays === null || nextDays === void 0 ? void 0 : nextDays.map(function (item, index) { return (React.createElement("option", { value: item.value, key: index.toString() }, item.label)); })),
            React.createElement("div", { className: "absolute flex items-center pointer-events-none select-position" },
                React.createElement("svg", { width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.19102 5.5919C3.44571 5.33916 3.85864 5.33916 4.11333 5.5919L8.00001 9.44944L11.8867 5.5919C12.1414 5.33916 12.5543 5.33916 12.809 5.5919C13.0637 5.84468 13.0637 6.25454 12.809 6.50733L8.46118 10.8225C8.20648 11.0753 7.79353 11.0753 7.53883 10.8225L3.19102 6.50733C2.93633 6.25454 2.93633 5.84469 3.19102 5.5919Z", fill: "#828096" })))),
        React.createElement("div", { className: "time-slots mt-2" }, availableSlots.map(function (item, index) {
            var selectedDate = moment(partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date).format("YYYY-MM-DD");
            var slotStartTime = moment("".concat(selectedDate, " ").concat(Number(item.value.split("-")[1]) - 1), "YYYY-MM-DD H");
            var isPast = moment().isAfter(slotStartTime);
            var isSelected = selectedTimeSlot === item.value;
            var isBooked = partnerSelectedSlot.timeSlot === item.value;
            return (React.createElement("button", { type: "button", key: index.toString(), className: "time-slot DMSanN_12_400 mb-1 ".concat(isPast
                    ? "disabled"
                    : isSelected || isBooked
                        ? "selected"
                        : "available-slot"), onClick: function () {
                    handleSelectTimeSlot(item);
                }, disabled: isPast || isBooked }, item.label));
        }))));
};
export default TimeSlotPicker;
